import yup from 'utilities/custom-yup-validation';
import Regex from '../constants/regex';
import Validation from '../constants/validation-messages';

/**
 * Types of User Details Schema Fields
 * @enum
 */
const UserDetails = {
  EMAIL_ID: 'emailId',
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  EMAIL: 'email',
  ACCOUNT_NUMBER: 'accountNumber'
};

/**
 * Schema for User Details Form.
 */
export const userDetailsFormSchema = yup.object().shape({
  [UserDetails.EMAIL_ID]: yup.string().email(Validation.EMAIL_VALID).required(Validation.EMAIL_REQUIRED),
  [UserDetails.FIRST_NAME]: yup.string().names(Validation.FIRST_NAME_VALID).required(Validation.FIRST_NAME_REQUIRED),
  [UserDetails.LAST_NAME]: yup.string().names(Validation.LAST_NAME_VALID).required(Validation.LAST_NAME_REQUIRED),
});

/**
 * Schema for Add User Details Form.
 */
export const addUserDetailsFormSchema = yup.object().shape({
  [UserDetails.FIRST_NAME]: yup.string().names(Validation.FIRST_NAME_VALID).required(Validation.FIRST_NAME_REQUIRED),
  [UserDetails.LAST_NAME]: yup.string().names(Validation.LAST_NAME_VALID).required(Validation.LAST_NAME_REQUIRED),
});

/**
 * Schema for Users List Filter in Customer Portal.
 */
export const customerUserListFilterSchema = yup.object().shape({
  [UserDetails.FIRST_NAME]: yup.string().nullable().names(Validation.FIRST_NAME_VALID),
  [UserDetails.LAST_NAME]: yup.string().nullable().names(Validation.LAST_NAME_VALID),
  [UserDetails.EMAIL]: yup.string().email(Validation.EMAIL_VALID),
});

/**
 * Schema for Users List Filter in Admin Portal.
 */
export const adminUserListFilterSchema = yup.object().shape({
  [UserDetails.FIRST_NAME]: yup.string().nullable().names(Validation.FIRST_NAME_VALID),
  [UserDetails.LAST_NAME]: yup.string().nullable().names(Validation.LAST_NAME_VALID),
  [UserDetails.EMAIL]: yup.string().email(Validation.EMAIL_VALID),
  [UserDetails.ACCOUNT_NUMBER]: yup.string().matches(Regex.ACCOUNT_NUMBER, { excludeEmptyString: true, message: Validation.ACCOUNT_NUMBER }),
});
